import React, { useState } from "react";
import IconRemove from "../Resources/svg/Icons/IconRemove";
import IconAdd from "../Resources/svg/Icons/IconAdd";

function BoxCounterFull({
  register,
  setVerifyYears,
  initCounter,
  setValue,
  incrementValue,
  title,
  nameVal,
  maxYear,
}) {
  const [num, setNum] = useState(initCounter ? initCounter : 1);
  const [numFormat, setNumFormat] = useState(initCounter);

  if (setVerifyYears) {
    setVerifyYears(num);
  }
  const handleChange = (event) => {
    setNumFormat(event.target.value);
  };

  const handleCLick = (type) => {
    if (num > 0 && type === "sum") {
      if (num === maxYear) return false;
      setValue(nameVal, num + incrementValue);
      setNum(num + incrementValue);
      setNumFormat(num + incrementValue);
    }
    if (num > 1 && type === "res") {
      setValue(nameVal, num - incrementValue);
      setNum(num - incrementValue);
      setNumFormat(num - incrementValue);
    }
  };

  return (
    <div className="boxCounter">
      {title && <div className="boxCounter__title">{title}</div>}
      <div className="boxCounter__boxes">
        <div
          className="boxCounter__boxes__wapper"
          id="box_decrement"
          onClick={() => handleCLick("res")}
        >
          <IconRemove color={num > 1 ? "#4F4FFF" : "#A9AFD9"} />
        </div>
        <input
          className="boxCounter__boxes__wapper-center"
          id="box_data_number"
          name={nameVal}
          ref={register}
          readOnly
          onChange={handleChange}
          value={
            numFormat === 0
              ? "6 meses"
              : `${numFormat.toLocaleString("en-IN", {
                  maximumFractionDigits: 2,
                })} ${numFormat > 1 ? "años" : "año"}`
          }
        />
        <div
          className="boxCounter__boxes__wapper"
          id="box_increment"
          onClick={() => handleCLick("sum")}
        >
          <IconAdd />
        </div>
      </div>
    </div>
  );
}

export default BoxCounterFull;
